import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  HStack,
  Heading,
  StackDivider,
  VStack
} from '@chakra-ui/react'
import { useSelector } from 'model/hooks'
import { FC, useMemo } from 'react'
import map from 'lodash/map'
import { ILanguage } from 'shared/types'
import EditableRow from 'components/EditableRow'
import sortBy from 'lodash/sortBy'
import { dbCreateLanguage, dbUpdateLanguage } from 'controllers/languages'

type Props = {}

const SettingsLanguages: FC<Props> = () => {
  const languages = useSelector(state => state.languages)

  const sortedLanguages = useMemo(() => sortBy(languages, 'title'), [languages])

  const renderRow = (p: ILanguage) => {
    return (
      <EditableRow
        key={p.id}
        value={p.title}
        onChange={v => dbUpdateLanguage(p.id, v)}
        // onDelete={() => dbDeleteLevel(p.id)}
      />
    )
  }

  return (
    <VStack w='full'>
      <Card w='full' maxW='2xl'>
        <CardHeader>
          <HStack w='full' justify={'space-between'}>
            <Heading size='md'>Languages</Heading>
            <Button
              colorScheme='teal'
              onClick={() => dbCreateLanguage()}
              size='sm'
            >
              Добавить
            </Button>
          </HStack>
        </CardHeader>
        <CardBody>
          <VStack w='full' divider={<StackDivider color='gray.100' />}>
            {map(sortedLanguages, renderRow)}
          </VStack>
        </CardBody>
        <CardFooter justify={'flex-end'}></CardFooter>
      </Card>
    </VStack>
  )
}

export default SettingsLanguages
